<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M13 3V9H21V3H13ZM13 21H21V11H13V21ZM3 21H11V15H3V21ZM3
    13H11V3H3V13Z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "PainelIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
